module.exports = __webpack_public_path__ + "img/switch-role-bg-feng.d46a4866.png";